import namor from 'namor'

const range = len => {
  const arr = []
  for (let i = 0; i < len; i++) {
    arr.push(i)
  }
  return arr
}

const newPerson = () => {
  const statusChance = Math.random()
  return {
    userName: namor.generate({ words: 1, numbers: 0 }),
    firstName: namor.generate({ words: 1, numbers: 0 }),
    lastName: namor.generate({ words: 1, numbers: 0 }),
    email : `${namor.generate({ words: 1, numbers: 0 })}@gmail.com`,
    age: Math.floor(Math.random() * 30),
    delete : '<button>delete</button>',
    status:
      statusChance > 0.66
        ? 'Active'
        : statusChance > 0.33
        ? 'Unactive'
        : 'Block',
  }
}

export default function makeData(...lens) {
  const makeDataLevel = (depth = 0) => {
    const len = lens[depth]
    return range(len).map(d => ({
        ...newPerson(),
        subRows: lens[depth + 1] ? makeDataLevel(depth + 1) : undefined,
      }))
  }

  return makeDataLevel()
}



// WEBPACK FOOTER //
// ./src/components/views/BuildCode/makeData.js